import { graphql } from '@prophecy/graphql-types/graphql';
import { gql } from 'graphql-request';
const ProjectQuery = ` project {
    _id
  }`;
export const EntityDetailQuery = (entity, isTeam) => gql `
  query GqlQuery_Page${entity}($uid: String!) {
    ${entity}(uid: $uid) {
      _id
      name
      ${isTeam ? '' : 'path'}
      ${isTeam ? '' : ProjectQuery}
    }
  }
`;
export const deleteEntityQuery = graphql(`
  mutation removeEntity($uid: String!, $entityKind: EntityKind!) {
    removeEntity(uid: $uid, entityKind: $entityKind) {
      _id
    }
  }
`);
export const updateEntityAspectQuery = graphql(`
  mutation upsertAspect($uid: String!, $entityKind: EntityKind!, $aspectKind: AspectKind!, $aspectValue: String!) {
    upsertAspect(uid: $uid, entityKind: $entityKind, aspectKind: $aspectKind, aspectValue: $aspectValue)
  }
`);
export const updateTeamInfoSettingsQuery = graphql(`
  mutation updateTeamInfoSettings(
    $teamUID: String!
    $transpilerEnabled: Boolean
    $description: String
    $entraIdEnabled: Boolean
    $assumedRoleEnabled: Boolean
  ) {
    updateTeamInfoSettings(
      teamUID: $teamUID
      transpilerEnabled: $transpilerEnabled
      description: $description
      entraIdEnabled: $entraIdEnabled
      assumedRoleEnabled: $assumedRoleEnabled
    )
  }
`);
export const updateEntityVersionedAspectQuery = graphql(`
  mutation upsertVersionedAspect(
    $uid: String!
    $entityKind: EntityKind!
    $aspectKind: AspectKind!
    $aspectValue: String!
  ) {
    upsertAspect(uid: $uid, entityKind: $entityKind, aspectKind: $aspectKind, aspectValue: $aspectValue)
  }
`);
export const updateEntityFieldQuery = graphql(`
  mutation updateEntity(
    $uid: String!
    $entityKind: EntityKind!
    $entityFieldName: String!
    $entityFieldValue: String!
  ) {
    updateEntity(
      uid: $uid
      entityKind: $entityKind
      entityFieldName: $entityFieldName
      entityFieldValue: $entityFieldValue
    )
  }
`);
export const cloneTemplateToTeamQuery = graphql(`
  mutation CloneTemplateToPersonalTeam($templateId: String!, $targetProjectName: String) {
    cloneTemplateToPersonalTeam(templateId: $templateId, targetProjectName: $targetProjectName) {
      _id
      name
    }
  }
`);
